<script setup lang="ts">
import AccountPageSummary from '~/components/@pages/accounts/[address]/AccountPageSummary.vue'
import AccountsPageTabs from '~/components/@pages/accounts/[address]/AccountsPageTabs.vue'
import BackButton from '~/components/button/BackButton.vue'

const address = useRoute().params.address as string

const ellipsisAddress = computed(() => {
  return `${address.slice(0, 8)}...${address.slice(-6)}`
})

useSeoMeta(getMeta(`Address ${ellipsisAddress.value}`, `Explore details of Address ${ellipsisAddress.value}`))
</script>

<template>
  <div class="relative">
    <BackButton :url="routes.getAccountsPage()" />
    <AccountPageSummary />
    <hr class="my-4 bg-primary opacity-10">
    <AccountsPageTabs class="relative z-10" />
    <NuxtPage />
  </div>
</template>

<style scoped lang="scss">

</style>